import { render, staticRenderFns } from "./PageReport.vue?vue&type=template&id=24e8a595&"
import script from "./PageReport.vue?vue&type=script&lang=js&"
export * from "./PageReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports